// extracted by mini-css-extract-plugin
export default {"container":"style_container__GQPG6","content":"style_content__7Rc6b"};